// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-RWTiyPP-9aHBYsTlP8uPg\\=\\={height:3.5rem;width:3.5rem}", "",{"version":3,"sources":["webpack://./../esm-styleguide/src/patient-photo/patient-photo.module.scss"],"names":[],"mappings":"AAAA,4BACE,aAAA,CACA,YAAA","sourcesContent":[".skeleton {\n  height: 3.5rem;\n  width: 3.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": "-RWTiyPP-9aHBYsTlP8uPg=="
};
export default ___CSS_LOADER_EXPORT___;
